import React from "react";

const CardGrid = ({ cards, placeholderText }) => {
  if (cards.length < 1) {
    return (
      <div className="ui two column centered grid">
        <div className="center aligned column">
          <p className="">{placeholderText}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ui stackable grid">
      <div className="column">
        <div className="ui centered link cards">{cards}</div>
      </div>
    </div>
  );
};

CardGrid.defaultProps = {
  placeholderText: "Nothing to show"
};

export default CardGrid;
